export const SIDEBAR_WIDTH = '250px';
export const SIDEBAR_COLLAPSED_WIDTH = '68px';
